import Axios, { AxiosInstance } from 'axios';
import { RequestConfig,handleServiceError } from './request_config';
import { TApiConfiguration } from './api_configuration';


export interface IApiClient {
  post<TRequest, TResponse>(
    path: string,
    object: TRequest,
    config?: RequestConfig
  ): Promise<TResponse>;
  patch<TRequest, TResponse>(
    path: string,
    object: TRequest
  ): Promise<TResponse>;
  put<TRequest, TResponse>(path: string, object: TRequest): Promise<TResponse>;
  get<TResponse>(path: string): Promise<TResponse>;
}

export class ApiClient implements IApiClient {
  private client: AxiosInstance;

  /* Costruttore, ritorna un istanza di axios con configurazioni passate da chi invoca */
  constructor(apiConfiguration: TApiConfiguration) {
    if(apiConfiguration.feow){
      this.client = this.createAxiosClient(apiConfiguration);
    }else{
      this.client = this.createAxiosClientHippo(apiConfiguration);
    }
    
  }


  /** Configurazioni di axios per avere l'istanza **/
  protected createAxiosClient(apiConfiguration: TApiConfiguration): AxiosInstance {
    return Axios.create({
      baseURL: apiConfiguration.urlApiBase,
      responseType: 'json' as const,
      headers: {
        'Content-Type': 'application/json',
        "Accept": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "*",
        "X-Requested-With": "XMLHttpRequest",
        'x-csrf-token': apiConfiguration.csrfToken,
        ...(apiConfiguration.accessToken && {
          Authorization: `Bearer ${apiConfiguration.accessToken}`,
        }),
        ...(apiConfiguration.feow && {
          FEOW: apiConfiguration.feow,
        }),
      },
      timeout: 120 * 1000,
    });
  }

  protected createAxiosClientHippo(apiConfiguration: TApiConfiguration): AxiosInstance {
    return Axios.create({
      baseURL: apiConfiguration.urlApiBase,
      responseType: 'json' as const,
      headers: {
        'Content-Type': 'application/json',
        "Accept": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "*",
        "X-Requested-With": "XMLHttpRequest",
        // 'x-csKrf-token': apiConfiguration.csrfToken,
        // ...(apiConfiguration.accessToken && {
        //   Authorization: `Bearer ${apiConfiguration.accessToken}`,
        // }),
        // ...(apiConfiguration.feow && {
        //   FEOW: apiConfiguration.feow,
        // }),
      },
      timeout: 60 * 1000,
    });
  }



  async post<TRequest, TResponse>(
    path: string,
    payload: TRequest,
    config?: RequestConfig
  ): Promise<TResponse> {
    try {
      const response = config
        ? await this.client.postForm<TResponse>(path, payload, config)
        : await this.client.postForm<TResponse>(path, payload);
      return response.data;
    } catch (error) {
      handleServiceError(error);
    }
    return {} as TResponse;
  }

  async patch<TRequest, TResponse>(
    path: string,
    payload: TRequest
  ): Promise<TResponse> {
    try {
      const response = await this.client.patch<TResponse>(path, payload);
      return response.data;
    } catch (error) {
      handleServiceError(error);
    }
    return {} as TResponse;
  }

  async put<TRequest, TResponse>(
    path: string,
    payload: TRequest
  ): Promise<TResponse> {
    try {
      const response = await this.client.put<TResponse>(path, payload);
      return response.data;
    } catch (error) {
      handleServiceError(error);
    }
    return {} as TResponse;
  }

  async get<TResponse>(path: string): Promise<TResponse> {
    try {
      const response = await this.client.get<TResponse>(path);
      return response.data;
    } catch (error) {
      handleServiceError(error);
    }
    return {} as TResponse;
  }
}